import Select, { Async, Creatable, AsyncCreatable } from 'react-select';
import decorateWithDefaultProps from 'components/decorate-with-default-props';

import selectComponentDecorator from './select-component-decorator';
import SearchArrowRenderer from './search-arrow-renderer';
import EllipsisArrowRenderer from './ellipsis-arrow-renderer';
import CogArrowRenderer from './cog-arrow-renderer';
import SelectMenuStandard from './select-menu-standard';
import SelectMenuWithHeader from './select-menu-with-header';

import OptionWithTick from './option-with-tick';
import OptionWithDescriptionRenderer from './option-with-description-renderer';

import styles from './select.less';

const defaultClassNameDecorator = decorateWithDefaultProps({
  className: styles.component,
  fullWidthClassName: styles['is-full-width'],
  isPrimaryClassName: styles['is-primary'],
  isMenuDetachedClassName: styles['is-menu-detached'],
  alignMenuClassName: {
    left: styles['align-left'],
    right: styles['align-right'],
  },
  menuPlacementClassName: {
    top: styles['menu-placement--top'],
    bottom: styles['menu-placement--bottom'],
  },
  sizeClassName: {
    xs: styles['size--xs'],
    sm: styles['size--sm'],
    m: styles['size--m'],
    lg: styles['size--lg'],
    xl: styles['size--xl'],
  },
  themeClassName: {
    raised: styles['theme--raised'],
    flat: styles['theme--flat'],
    empty: styles['theme--empty'],
  },
});

const DecoratedSelect = defaultClassNameDecorator(
  Select,
  selectComponentDecorator
);

const DecoratedAsync = defaultClassNameDecorator(
  Async,
  selectComponentDecorator
);

const DecoratedCreatable = defaultClassNameDecorator(
  Creatable,
  selectComponentDecorator
);

const DecoratedAsyncCreatable = defaultClassNameDecorator(
  AsyncCreatable,
  selectComponentDecorator
);

export default DecoratedSelect;
export {
  DecoratedSelect as Select,
  DecoratedAsync as Async,
  DecoratedCreatable as Creatable,
  DecoratedAsyncCreatable as AsyncCreatable,
  SearchArrowRenderer,
  EllipsisArrowRenderer,
  CogArrowRenderer,
  SelectMenuStandard,
  SelectMenuWithHeader,
  OptionWithTick,
  OptionWithDescriptionRenderer,
};
